import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
export function WhyThisDevice() {
  const comparison = [{
    feature: 'Wavelength',
    generic: 'Vague "red light" claims',
    crowncontrol: '650-670nm clinical window'
  }, {
    feature: 'Power Density',
    generic: 'Hidden or under-spec',
    crowncontrol: 'Matched to FDA trial specs'
  }, {
    feature: 'Progress Tracking',
    generic: 'None — just hope it works',
    crowncontrol: 'Photo check-ins at months 3 & 6'
  }, {
    feature: 'Clinical Backing',
    generic: 'Marketing claims only',
    crowncontrol: 'FDA 510(k) cleared device class'
  }, {
    feature: 'Guarantee',
    generic: '30-60 days (not enough time)',
    crowncontrol: '180 days — see real results'
  }];
  return <section className="w-full bg-gray-50 py-20 px-4" data-id="element-320">
      <div className="max-w-6xl mx-auto" data-id="element-321">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-322">
          {/* Headline */}
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 text-center" data-id="element-323">
            Why Most Laser Caps Don't Work
          </h2>
          <p className="text-xl text-gray-700 mb-12 text-center max-w-3xl mx-auto" data-id="element-324">
            Most caps under-dose, over-promise, and never check if follicles are
            still alive. CrownControl™ is calibrated to clinical dosing and
            structured check-ins so you know if it's working on your head.
          </p>

          {/* Comparison Table */}
          <div className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-325">
            <div className="grid grid-cols-3 bg-gray-100 p-4 font-bold text-gray-900" data-id="element-326">
              <div data-id="element-327"></div>
              <div className="text-center" data-id="element-328">Generic Caps</div>
              <div className="text-center text-brand-red" data-id="element-329">CrownControl™</div>
            </div>
            {comparison.map((row, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.1
          }} className="grid grid-cols-3 p-4 border-t border-gray-200 items-center" data-id="element-330">
                <div className="font-semibold text-gray-900" data-id="element-331">{row.feature}</div>
                <div className="text-center flex items-center justify-center gap-2" data-id="element-332">
                  <XIcon className="w-5 h-5 text-red-500 flex-shrink-0" aria-hidden="true" data-id="element-333" />
                  <span className="text-sm text-gray-600" data-id="element-334">{row.generic}</span>
                </div>
                <div className="text-center flex items-center justify-center gap-2" data-id="element-335">
                  <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" aria-hidden="true" data-id="element-336" />
                  <span className="text-sm text-gray-900 font-medium" data-id="element-337">
                    {row.crowncontrol}
                  </span>
                </div>
              </motion.div>)}
          </div>

          {/* Mechanism Statement */}
          <div className="mt-12 bg-brand-red/5 border-l-4 border-brand-red rounded-lg p-6" data-id="element-338">
            <p className="text-lg text-gray-900 leading-relaxed" data-id="element-339">
              <strong data-id="element-340">The difference:</strong> Photobiomodulation requires the
              right wavelength, at the right power density, for the right
              duration. Miss any variable and you're not treating anything —
              you're just wearing a hat with LEDs. CrownControl™ gets all three
              right, then proves it with structured tracking.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}